// Flanking Maneuver knight-move destination scope. Pure. No React, no
// Three.js.
//
// ── Codex ──
//   "Teleport any number of allies at one location to another location
//    a CHESS KNIGHT'S MOVE away."
//
// A knight's move is the 8 (±1, ±2) / (±2, ±1) offsets from a source
// cell. This helper enumerates the on-grid knight destinations of a
// source cell so the runtime can offer them as the teleport destination
// halo. The group-teleport mechanics (selecting any number of allies at
// the source cell, moving them together) live in the runtime; this is
// just the destination geometry.

const KNIGHT_OFFSETS = [
  [1, 2], [2, 1], [2, -1], [1, -2],
  [-1, -2], [-2, -1], [-2, 1], [-1, 2],
];

/**
 * On-grid knight-move destinations of `sourceCell`.
 *
 * @param sourceCell  { col, row }
 * @param totalCols / totalRows  grid dimensions
 * @returns {{ col, row }[]} legal knight destinations (may be empty)
 */
export function knightMoveCells(sourceCell, totalCols, totalRows) {
  if (!sourceCell) return [];
  const { col, row } = sourceCell;
  return KNIGHT_OFFSETS
    .map(([dc, dr]) => ({ col: col + dc, row: row + dr }))
    .filter((c) => c.col >= 0 && c.col < totalCols && c.row >= 0 && c.row < totalRows);
}
